import React from 'react';

const PauseIcon = ({
  width = 40,
  height = 40,
  color = 'var(--ca-theme-palette-colors-controlButtonColor, #4B1C46)',
  bg = 'white',
  className = '',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <circle cx="20" cy="20" r="19.1667" fill={bg} stroke={color} strokeWidth="1.66667" />
    <path d="M15.2727 14.5455V25.4545" stroke={color} strokeWidth="3.63636" strokeLinecap="round" />
    <path d="M24.7273 14.5455V25.4545" stroke={color} strokeWidth="3.63636" strokeLinecap="round" />
  </svg>
);

export default PauseIcon;
